import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@material-ui/core';

interface Props {
  open: boolean;
  title: string;
  text: string;
  onNo: () => void;
  onYes: () => void;
}

const AreYouSure: React.FunctionComponent<Props> = React.memo((props) => {
  return (
    <Dialog
      open={props.open}
      onClose={props.onNo}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{props.title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">{props.text}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onNo} color="secondary" autoFocus>
          Cancel
        </Button>
        <Button onClick={props.onYes} color="primary">
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
});

export default AreYouSure;
